import Vue from 'vue';
import Router from 'vue-router';

import PPanel from '@/pages/p-panel';

import P404 from '@/pages/p-404';

import PageDashboard from '@/pages/PageDashboard';

import PagePresentationSettings from '@/pages/PagePresentationSettings';
import PPresentations from '@/pages/p-presentations';
import PEditor from '@/pages/p-editor';
import CEditorCharts from '@/components/p-editor/c-editor-charts';


import PRolePermission from '@/pages/p-role-permission';
import PUserform from '@/pages/p-userform';

import PStyleguide from '@/pages/p-styleguide';
import PTranslations from '@/pages/p-translations';
import PageGroup from '@/pages/PageGroup';
import PageGroupReset from '@/pages/PageGroupReset';

import PageTest from '@/pages/PageTest';
import PageSettings from '@/pages/PageSettings';


import PageUser from '@/pages/PageUser';
import PageUserOverview from '@/pages/PageUserOverview';

import PageChannel from '@/pages/PageChannel';
import PageMediaStore from '@/pages/PageMediaStore';

import PagePartnerOverview from '@/pages/PagePartnerOverview';
import PagePartner from '@/pages/PagePartner';

import PageCustomerOverview from '@/pages/PageCustomerOverview';
import PageCustomer from '@/pages/PageCustomer';

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '404',
			from: '*',
			component: P404
		},

		{
			path: '/panel',
			component: PPanel,
				children: [
				{
					path: '404',
					component: P404
				},

				{
					path: 'channel',
					component: PageChannel
				},

				{
					name: 'media_store',
					path: 'media_store',
					component: PageMediaStore
				},
				{
					name: 'test',
					path: 'test',
					component: PageTest
				},
				{
					name: 'settings',
					path: 'settings',
					component: PageSettings
				},

				{
					path: '',
					alias: 'home',
					component: PageDashboard
				},

				{
					name: 'styleguide',
					path: 'styleguide',
					component: PStyleguide
				},
				{
					name: 'translations',
					path: 'translations',
					component: PTranslations
				},
				{
					path: 'partners',
					component: PageGroupReset,
					canReuse: false,
					children: [
						{
							name: 'partner-list',
							path: '',
							component: PagePartnerOverview,
						},
						{
							path: 'users/:uid',
							component: PageUser,
							props: (route) => {
								let p = route.params;
								p.role = 'partner';
								return p;
							},
							children: [
								{
									name: 'partner-user',
									path: '',
									component: PUserform
								}
							]
						},
						{
							path: ':id',
							component: PageGroup,
							props: true,
							children: [
								{
									name: 'partner',
									path: '',
									component: PagePartner,
									props: true,
								},
								{
									path: 'users',
									component: PageGroup,
									children: [
										{
											name: 'partner-user-list',
											path: '',
											component: PageUserOverview,
											props: (route) => {
												let p = route.params;
												if(p.id) p.partnerid = p.id;
												p.role = 'partner';
												return p;
											},
										},
										{
											name: 'partner-user-leader-list',
											path: 'leaders',
											component: PageUserOverview,
											props: (route) => {
												let p = route.params;
												p.role = 'partner_leader';
												if(p.id) p.partnerid = p.id;
												return p;
											},
										},
										{
											path: ':uid',
											component: PageUser,
											props: (route) => {
												let p = route.params;
												if(p.id) p.partnerid = p.id;
												p.role = 'partner';
												return p;
											},
											children: [
												{
													name: 'partner-user-child',
													path: '',
													component: PUserform
												}
											]
										},
										{
											path: 'leaders/:uid',
											component: PageUser,
											props: (route) => {
												let p = route.params;
												if(p.id) p.partnerid = p.id;
												p.role = 'partner_leader';
												return p;
											},
											children: [
												{
													name: 'partner-leader-user',
													path: '',
													component: PUserform
												}
											]
										},
									]
								},
								{
									name: 'partner-editor',
									path: 'editor',
									component: PEditor,
									children: [
										{
											name: 'partner-chart',
											path: ':chartid',
				    						props: true,
											component: CEditorCharts
										},
									]
								}
							]
						}
					]
				},
				{
					path: 'customers',
					component: PageGroupReset,
					canReuse: false,
					children: [
						{
							name: 'customer-list',
							path: '',
							component: PageCustomerOverview,
						},
						{
							name: 'customer',
							path: ':id',
							component: PageCustomer,
							props: true,
							children: [
								{
									name: 'customer-editor',
									path: 'editor',
									component: PEditor,
									children: [
										{
											name: 'customer-chart',
											path: ':chartid',
				    						props: true,
											component: CEditorCharts
										},
									]
								}
							]
						}
					]
				},
				{
					path: 'users',
					component: PageGroupReset,
					canReuse: false,
					children: [
						{
							name: 'user-list',
							path: ':role',
							component: PageUserOverview,
							props: true
						},
						{
							name: 'user-permissions',
							path: ':role/permissions',
							component: PRolePermission,
							props: true
						},
						{
							path: ':role/:uid',
							component: PageUser,
							props: true,
							children: [
								{
									name: 'user-edit',
									path: '',
									component: PUserform
								}
							]
						},
					]
				},

				{
					path: 'master-slides',
					component: PEditor,
					props: {
						master: true,
					},
					children: [
		    			{
		    				name: 'master-chart',
		    				path: ':chartid',
		    				props: true,
		    				component: CEditorCharts
		    			}
					]
				},
				{
					path: 'presentation',
					component: PageGroupReset,
					canReuse: false,
					children: [
						{
							name: 'presentation-list',
							path: '',
							component: PPresentations,
							canReuse: false,
						},
						{
							name: 'presentation-new',
							path: 'new',
							component: PagePresentationSettings,
							canReuse: false,
						},
						{
							name: 'presentation-settings',
							path: 'settings/:pid',
							component: PagePresentationSettings,
							canReuse: false,
							props: true,
						},
						{
							name: 'editor',
							path: 'edit/:pid',
							props: true,
							component: PEditor,
							children: [
			        			{
			        				name: 'presentation-chart',
			        				path: ':chartid',
			        				props: true,
			        				component: CEditorCharts
			        			}
			      			]
		      			}
					]
				},
				{
					path: '*',
					redirect: '404'
				},
			],
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js